import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { setTelegramModal } from "../../../redux/features/plan/slice";

//
import { Modal } from "react-bootstrap";

//
import SocialAccounts from "./SocialAccounts";

function ConnectTelegramModal({ telegramModal, setTelegramModal }) {
  return (
    <Modal
      show={telegramModal}
      onHide={() => setTelegramModal(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="telegram-modal"
    >
      <Modal.Header closeButton>
        <h5>Connect to Telegram Account</h5>
        <p className="subject">Connect to telegram account to get signals</p>
      </Modal.Header>
      <Modal.Body>
        <SocialAccounts modal />
      </Modal.Body>
    </Modal>
  );
}

ConnectTelegramModal.propTypes = {
  telegramModal: PropTypes.bool.isRequired,
  setTelegramModal: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setTelegramModal,
};

const mapStateToProps = (state) => ({
  telegramModal: state.planReducer.telegramModal,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectTelegramModal);
